import ElementBound from '../core/ElementBound';
import { getAppData, $http } from 'larasnap';

export default class extends ElementBound {
    _active;
    _settings;

    constructor(element) {
        super(element);

        const data = getAppData('adminSettings');
        this._active = data.active;
        this._settings = data.settings;

        this.find('button[name=apply]').click(this.apply.bind(this));
        this.find('button[name=clear]').click(this.clear.bind(this));
    }

    apply() {
        $http.route('apply_admin_settings').post('', {
            settings: this.getSettings(),
        });
    }

    clear() {
        $http.route('clear_admin_settings').post();
    }

    getSettings() {
        const getValue = key => {
            const input = this.find(`:input[name="${key}"]`);
            if (input.attr('type') === 'checkbox') {
                return input.is(':checked');
            } else {
                return input.val();
            }
        };

        return Object.fromEntries(
            Object.keys(this._settings).map(key => [key, getValue(key)]),
        );
    }
}
